import React from "react"
import Select, {
  components as reactSelectComponents,
  NoticeProps,
  Props as SelectProps
} from "react-select"

import { cn } from "lib/utils"
import usePrefix from "utils/usePrefix"

export interface SingleSelectOption {
  value: string | number
  label: string | number
  icon?: React.ReactNode
  optionDisabled?: boolean
}

type SingleSelectProps = SelectProps<SingleSelectOption> & {
  showErrorStyles?: boolean
}

const SingleSelect: React.FC<SingleSelectProps> = React.memo(
  ({
    hideSelectedOptions = false,
    isSearchable = false,
    isClearable = false,
    placeholder,
    value,
    components,
    className,
    showErrorStyles,
    ...props
  }) => {
    const t = usePrefix("General")

    const NoOptionsMessage = (props: NoticeProps<SingleSelectOption>) => {
      return (
        <reactSelectComponents.NoOptionsMessage {...props}>
          {t("no_data")}
        </reactSelectComponents.NoOptionsMessage>
      )
    }

    return (
      <Select
        {...props}
        placeholder={placeholder || t("search")}
        isMulti={false}
        hideSelectedOptions={hideSelectedOptions}
        isSearchable={isSearchable}
        isClearable={isClearable}
        isOptionDisabled={(option) => !!option.optionDisabled}
        value={value}
        components={{
          ...components,
          NoOptionsMessage
        }}
        className={cn("my-react-select-container", className)}
        classNamePrefix="my-react-select"
        styles={{
          control: (baseStyles) => {
            if (!showErrorStyles) return baseStyles

            const errorStyles = {
              border: "none",
              boxShadow: "0px 0px 0px 1px #E5202E",
              "--tw-ring-color": "rgba(229, 32, 46, 0.5) !important"
            }

            return {
              ...baseStyles,
              ...errorStyles,
              "&:hover": errorStyles,
              "&:focus": errorStyles
            }
          }
        }}
      />
    )
  }
)

export default SingleSelect
